import React from 'react';
import { HyperText } from '../components/HyperText';
import { Grid } from '../components/ui/GridPattern';
import { CheckIcon, XIcon } from 'lucide-react';
const AboutPage = () => {
  return <div className="w-full min-h-screen bg-center bg-cover bg-no-repeat bg-gray-900" data-id="element-297">
      <div className="pt-28 sm:pt-32 md:pt-40 pb-6 sm:pb-10" data-id="element-298">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-light text-white text-center tracking-normal px-4" data-id="element-299">
          About Us
        </h1>
      </div>
      <div className="py-12 sm:py-16 md:py-24" data-id="element-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-301">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 md:gap-12 mb-10 sm:mb-16" data-id="element-302">
            <div className="relative bg-gradient-to-b from-gray-900/50 to-gray-900/30 p-4 sm:p-6 md:p-8 rounded-2xl border border-gray-700 shadow-sm overflow-hidden" data-id="element-303">
              <Grid size={20} data-id="element-304" />
              <div className="relative z-20" data-id="element-305">
                <h2 className="text-2xl sm:text-3xl font-light text-white mb-4 sm:mb-6 tracking-normal" data-id="element-306">
                  Mission
                </h2>
                <p className="text-base sm:text-lg md:text-xl text-gray-300 font-light" data-id="element-307">
                  To empower the chiropractic industry and maximize holistic
                  healthcare through acquisition, resource consolidation, and
                  service integration.
                </p>
              </div>
            </div>
            <div className="relative bg-gradient-to-b from-gray-900/50 to-gray-900/30 p-4 sm:p-6 md:p-8 rounded-2xl border border-gray-700 shadow-sm overflow-hidden" data-id="element-308">
              <Grid size={20} data-id="element-309" />
              <div className="relative z-20" data-id="element-310">
                <h2 className="text-2xl sm:text-3xl font-light text-white mb-4 sm:mb-6 tracking-normal" data-id="element-311">
                  Vision
                </h2>
                <p className="text-base sm:text-lg md:text-xl text-gray-300 font-light" data-id="element-312">
                  To bring a fragmented industry together and help clinics reach
                  their full potential.
                </p>
              </div>
            </div>
          </div>
          {/* Who We Are Section */}
          <div className="relative bg-gradient-to-b from-gray-900/50 to-gray-900/30 p-4 sm:p-6 md:p-8 rounded-2xl border border-gray-700 shadow-sm mb-10 sm:mb-16" data-id="element-313">
            <h2 className="text-2xl sm:text-3xl font-light text-white mb-6 sm:mb-8 text-center tracking-normal" data-id="element-314">
              Who We Are
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-10" data-id="element-315">
              {/* Left Column - What We Are */}
              <div className="space-y-4" data-id="element-316">
                {weAreItems.map((item, index) => <div key={`we-are-${index}`} className="flex items-start gap-3 bg-gray-900/30 p-3 sm:p-4 rounded-lg border border-gray-800/50 transition-all duration-300 hover:border-[#4ECDC4]/50 hover:shadow-[0_0_15px_rgba(78,205,196,0.15)]" data-id="element-317">
                    <div className="flex-shrink-0 p-1.5 bg-green-500/20 rounded-full" data-id="element-318">
                      <CheckIcon className="w-5 h-5 text-green-500" data-id="element-319" />
                    </div>
                    <p className="text-gray-200 font-light" data-id="element-320">{item}</p>
                  </div>)}
              </div>
              {/* Right Column - What We Are Not */}
              <div className="space-y-4" data-id="element-321">
                {weAreNotItems.map((item, index) => <div key={`we-are-not-${index}`} className="flex items-start gap-3 bg-gray-900/30 p-3 sm:p-4 rounded-lg border border-gray-800/50 transition-all duration-300 hover:border-red-500/50 hover:shadow-[0_0_15px_rgba(239,68,68,0.15)]" data-id="element-322">
                    <div className="flex-shrink-0 p-1.5 bg-red-500/20 rounded-full" data-id="element-323">
                      <XIcon className="w-5 h-5 text-red-500" data-id="element-324" />
                    </div>
                    <p className="text-gray-200 font-light" data-id="element-325">{item}</p>
                  </div>)}
              </div>
            </div>
          </div>
          <div className="relative bg-gradient-to-b from-gray-900/50 to-gray-900/30 p-4 sm:p-6 md:p-8 rounded-2xl border border-gray-700 shadow-sm mb-10 sm:mb-16" data-id="element-326">
            <div data-id="element-327">
              <h2 className="text-2xl sm:text-3xl font-light text-white mb-4 sm:mb-8 text-center tracking-normal" data-id="element-328">
                Core Pillars
              </h2>
              <p className="text-base sm:text-lg md:text-xl text-[#4ECDC4] mb-6 sm:mb-8 text-center font-light" data-id="element-329">
                We Care about our commitments to the...
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-330">
                {corePillars.map((pillar, index) => <div key={index} className="bg-gradient-to-b from-gray-900/50 to-gray-900/30 p-4 sm:p-6 rounded-xl border border-gray-700 shadow-sm" data-id="element-331">
                    <h3 className="text-lg sm:text-xl font-light text-white mb-2 sm:mb-3 tracking-normal" data-id="element-332">
                      {pillar.title}
                    </h3>
                    <p className="text-sm sm:text-base text-gray-300 font-light" data-id="element-333">
                      {pillar.description}
                    </p>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
const weAreItems = ['We directly purchase your clinic', 'We source and hire your replacement', 'We keep your staff in place', 'We grow and scale your practice', 'We are privately owned and operated', 'We protect your legacy'];
const weAreNotItems = ['We are NOT a Franchise or Brokers', 'We are NOT passive owners', 'We do NOT fire your staff', 'We do NOT compromise care', 'We do NOT charge any fees to close', 'We do NOT rebrand your clinic'];
const corePillars = [{
  title: 'Well-being of patients',
  description: 'We prioritize patient-centered care, ensuring comfort, dignity, and the highest quality of life.'
}, {
  title: 'Empowerment of team members',
  description: 'We foster an environment where our team can thrive professionally and personally.'
}, {
  title: 'Collaboration across the industry',
  description: 'We build meaningful partnerships to advance healthcare delivery and outcomes.'
}, {
  title: 'Accountability to stakeholders',
  description: 'We take responsibility for our actions and decisions, ensuring transparency and trust.'
}, {
  title: 'Responsibility of upholding integrity',
  description: 'We adhere to the highest ethical standards in all our operations and interactions.'
}, {
  title: 'Excellence of the highest of standards',
  description: 'We continuously strive to exceed expectations in every aspect of our service.'
}];
export default AboutPage;